var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_1628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.26803 0 0 6.26803 0 14C0 21.732 6.26803 28 14 28C21.732 28 28 21.732 28 14C28 6.26803 21.732 0 14 0ZM6.72093 11.5954H9.89363V21.1281H6.72093V11.5954ZM10.1026 8.64657C10.082 7.7119 9.41366 7 8.32825 7C7.2429 7 6.53333 7.7119 6.53333 8.64657C6.53333 9.56188 7.22196 10.2943 8.28707 10.2943H8.30737C9.41366 10.2943 10.1026 9.56188 10.1026 8.64657ZM17.6826 11.3716C19.7705 11.3716 21.3356 12.7343 21.3356 15.6623L21.3355 21.1281H18.163V16.0281C18.163 14.7471 17.7038 13.8729 16.5553 13.8729C15.6788 13.8729 15.1567 14.4622 14.9274 15.0314C14.8435 15.2354 14.8229 15.5196 14.8229 15.8045V21.1283H11.6498C11.6498 21.1283 11.6916 12.4902 11.6498 11.5957H14.8229V12.9459C15.244 12.2968 15.9981 11.3716 17.6826 11.3716Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_1628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9b14f1bd50bf8f37c372a39b9c85200.svg";
export { ForwardRef as ReactComponent };